import { render, staticRenderFns } from "./ModalTermos.vue?vue&type=template&id=16feec7c"
import script from "./ModalTermos.vue?vue&type=script&lang=js"
export * from "./ModalTermos.vue?vue&type=script&lang=js"
import style0 from "./ModalTermos.vue?vue&type=style&index=0&id=16feec7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports